'use client';

import { useCurrentLocale } from '@locales/client';
import {
  getAllowedLanguages,
  getDefaultLanguage,
} from '@/shared/hooks/useBrandTheme';
import { usePathname } from 'next/navigation';

export default function HreflangTags() {
  const pathname = usePathname();
  const currentLocale = useCurrentLocale();
  const allowedLanguages = getAllowedLanguages();
  const defaultLanguage = getDefaultLanguage();

  const baseUrl =
    typeof window !== 'undefined' &&
    `${window.location.protocol}//${window.location.host}`;

  const getCleanPath = (): string => {
    for (const locale of allowedLanguages) {
      if (pathname === `/${locale}`) return '';
      if (pathname.startsWith(`/${locale}/`)) {
        return pathname.slice(locale.length + 1);
      }
    }
    return pathname;
  };

  const cleanPath = getCleanPath();

  return (
    baseUrl && (
      <>
        {allowedLanguages.map(
          (locale) =>
            locale !== currentLocale && (
              <link
                key={locale}
                rel="alternate"
                hrefLang={locale}
                href={`${baseUrl}/${locale}${cleanPath}`}
              />
            )
        )}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`${baseUrl}/${defaultLanguage}${cleanPath}`}
        />
      </>
    )
  );
}
